import { render, staticRenderFns } from "./ISACloseFollowUpHelp.vue?vue&type=template&id=2fa41e9e&scoped=true&"
import script from "./ISACloseFollowUpHelp.vue?vue&type=script&lang=js&"
export * from "./ISACloseFollowUpHelp.vue?vue&type=script&lang=js&"
import style0 from "./ISACloseFollowUpHelp.vue?vue&type=style&index=0&id=2fa41e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa41e9e",
  null
  
)

export default component.exports